import apiClient from '../config/axios';
import ENDPOINTS from '../constants/endpoints';

export const articleService = {
  // Get articles with pagination and filters
  getArticles: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      // Build the URL with path parameters for pagination
      const url = `${ENDPOINTS.ARTICLES}/${pageSize}/${page}`;
      
      // Build query parameters for filters only
      const params = {};

      // Add filters if they exist
      if (filters.searchTerms) {
        params.searchTerms = filters.searchTerms;
      }
      if (filters.LocalId) {
        params.LocalId = filters.LocalId;
      }
      if (filters.ClientId) {
        params.ClientId = filters.ClientId;
      }
      if (filters.CodeABarre) {
        params.CodeABarre = filters.CodeABarre;
      }
      if (filters.NumeroDeSerie) {
        params.NumeroDeSerie = filters.NumeroDeSerie;
      }

      const response = await apiClient.get(url, {
        params: params
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching articles:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des articles',
        error: error.response?.data,
      };
    }
  },

  getArticleByCodeABarre: async (codeABarre) => {
    try {
      const response = await apiClient.get(ENDPOINTS.GET_BY_CODE_A_BARRE(codeABarre));
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get article by code à barre error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement de l\'article par code à barre',
        error: error.response?.data,
      };
    }
  },

  // Get article by ID - Updated to use detailed endpoint
  getArticleById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.ARTICLES}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get article by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement de l\'article',
        error: error.response?.data,
      };
    }
  },

  // Create new article
  createArticle: async (articleData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.ARTICLES, articleData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Create article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création de l\'article',
        error: error.response?.data,
      };
    }
  },

  // Update article
  updateArticle: async (id, articleData) => {
    try {
      const response = await apiClient.put(`${ENDPOINTS.ARTICLES}`, articleData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Update article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour de l\'article',
        error: error.response?.data,
      };
    }
  },

  // Delete article
  deleteArticle: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.ARTICLES}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Delete article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression de l\'article',
        error: error.response?.data,
      };
    }
  },

  exportArticlesExcelByClient: async (clientId) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.ARTICLES}/ExcelbyClient/${clientId}`, {
        responseType: 'blob', 
      });
      return {
        success: true,
        data: response.data,
        filename: response.headers['content-disposition']
      };
    } catch (error) {
      console.error('Export articles Excel by client error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de l\'export Excel',
        error: error.response?.data,
      };
    }
  },

  downloadInterventionPdf: async (interventionId) => {
    try {
      const response = await apiClient.get(
        `${ENDPOINTS.ARTICLES}/PdfIntervention/${interventionId}`,
        { responseType: 'blob' }
      );
      return {
        success: true,
        data: response.data,
        filename: response.headers['content-disposition']
      };
    } catch (error) {
      console.error('Download intervention PDF error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du téléchargement du PDF',
        error: error.response?.data,
      };
    }
  },
};

export default articleService;